import { FC, Fragment } from 'react';

// Third-party
import ListItem from '@mui/material/ListItem';
import ListItemText from '@mui/material/ListItemText';
import Divider from '@mui/material/Divider';
import List from '@mui/material/List';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

// Hooks
import { useTheme } from '@mui/material';
import { TCustomTheme } from '@mgm/common/theme';
import { useCustomTheme } from '@mgm/common/hooks/useCustomTheme';
import { toFixedString } from '@mgm/common/utils';
import { useAppSelector } from '../../../../hooks/useAppStore';

// Redux-toolkit
import { getCurrencyById } from '../../../../store/common/selectors';

// Types
import { TCurrencyList } from '../type';

const CurrencyList: FC<TCurrencyList> = ({ currencies }) => {
  const getCurrency = useAppSelector(getCurrencyById);
  const theme = useTheme() as TCustomTheme;
  const { isLight } = useCustomTheme(theme);

  return (
    <List sx={{ width: '100%', maxWidth: 360, bgcolor: !isLight ? 'rgb(33, 43, 54)' : '#fff' }}>
      {currencies.map((currency) => (
        <Fragment key={currency.currencyAmount}>
          <ListItem
            sx={{
              py: 0,
            }}
            alignItems="flex-start"
          >
            <ListItemText
              primary={(
                <Box display="flex" justifyContent="space-between">
                  <Box paddingRight={2} display="flex" alignItems="center">
                    <Typography
                      {...(isLight && {
                        color: 'rgb(33, 43, 54)',
                      })}
                    >
                      {toFixedString(currency.currencyAmount, 2)}
                    </Typography>
                    <Typography {...(isLight && {
                      color: 'rgb(33, 43, 54)',
                    })}
                    >
                      {getCurrency(Number(currency.currencyId) || 2).mark}
                    </Typography>
                  </Box>
                  <Typography {...(isLight && {
                    color: 'rgb(33, 43, 54)',
                  })}
                  >
                    (
                    {getCurrency(Number(currency.currencyId) || 2).code}
                    )
                  </Typography>
                </Box>
              )}
            />
          </ListItem>
          <Divider
            sx={{
              borderStyle: 'dashed',
            }}
            variant="inset"
            component="li"
          />
        </Fragment>
      ))}
    </List>
  );
};

export {
  CurrencyList,
};
